export const addIcon = { iconName: "Add" };
export const signOutIcon = { iconName: "SignOut" };
export const cancelIcon = { iconName: "Cancel" };
export const refreshIcon = { iconName: "Refresh" };
export const productIcon = { iconName: "Product" };
export const editIcon = { iconName: "Edit" };
export const deleteIcon = { iconName: "Delete" };
export const entryViewIcon = { iconName: "EntryView" };
export const moreIcon = { iconName: "More" };
export const peopleIcon = { iconName: "People" };
